import request from './request';

const important_note = {
	async createApplication(body) {
		const res = await request.post('/app/applications', body);
		return res;
	},
	async updateApplication(id, body) {
		const res = await request.patch(`/app/applications/id?id=${id}`, body);
		return res;
	},
	async getEvent(query) {
		const res = await request.get('/app/applications/event', query);
		return res;
	}
};

export default important_note;